/* eslint-disable @next/next/no-img-element */
import styled from '@emotion/styled';
import { Fragment } from 'react';
import PropTypes from 'prop-types';
import H1 from '@base/H1/H1';
import H2 from '@base/H2/H2';
import { useSelector } from 'react-redux';
import H4 from '@base/H4/H4';
import { mobile, Spacings, Fonts } from '@styles/index';
import { getImage } from '@utils/imageHelper';
import ScaledImage from './ScaledImage';

const Wrapper = styled.div`
  margin: auto;
  max-width: 1136px;
  @media only screen and (max-width: ${mobile.maxWidth}) {
    width: 300px;
  }
  h1 {
    font-size: 40px;
    max-width: 600px;
    margin: auto;
    text-align: center;
    padding-bottom: ${Spacings.SPACING_14B};
    margin-bottom: ${Spacings.SPACING_4B};
    @media only screen and (max-width: ${mobile.maxWidth}) {
      font-size: ${Fonts.H3};
      padding-bottom: ${Spacings.SPACING_0B};
      margin-bottom: ${Spacings.SPACING_10B};
    }
  }
`;

const RoadmapWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: ${({ isRight }) => (isRight ? 'row-reverse' : 'row')};
  justify-content: space-evenly;
  @media only screen and (max-width: ${mobile.maxWidth}) {
    flex-direction: column;
  }
  img {
    height: 512px;
    @media only screen and (max-width: ${mobile.maxWidth}) {
      margin-top: ${Spacings.SPACING_10B};
    }
  }
`;

const TextBlock = styled.div`
  /* flex: 1; */
  @media only screen and (max-width: ${mobile.maxWidth}) {
    text-align: center;
  }
  h2 {
    max-width: 400px;
    margin-top: ${Spacings.SPACING_6B};
    margin-bottom: ${Spacings.SPACING_6B};
    @media only screen and (max-width: ${mobile.maxWidth}) {
      font-size: ${Fonts.H4};
      margin-top: ${Spacings.SPACING_4B};
      margin-bottom: ${Spacings.SPACING_2B};
    }
  }
  h4 {
    font-weight: normal;
    color: var(--color-text-secondary);
    max-width: 400px;
    @media only screen and (max-width: ${mobile.maxWidth}) {
      font-size: ${Fonts.H6};
    }
  }
`;

const Logo = styled(ScaledImage)`
  @media only screen and (max-width: ${mobile.maxWidth}) {
    margin: auto;
  }
  img {
    @media only screen and (max-width: ${mobile.maxWidth}) {
      margin-top: ${Spacings.SPACING_0B};
    }
  }
`;

const Connector = styled.img`
  margin: ${Spacings.SPACING_5B} 35%;
  @media only screen and (max-width: ${mobile.maxWidth}) {
    display: none;
  }
`;

const CombatsRoadmap = ({ goalUID }) => {
  const data = useSelector(({ combats }) => combats.staticData[goalUID] || {});
  const connectors = [
    getImage('combat/Dotted line - 1.svg'),
    getImage('combat/Dotted line - 2.svg'),
    getImage('combat/Dotted line - 3.svg'),
    getImage('combat/Dotted line - 4.svg'),
    getImage('combat/Dotted line - 5.svg')
  ];
  return (
    <Wrapper id="contests-roadmap">
      <H1>{data.roadmapHeading}</H1>
      {data.roadmap
        ? data.roadmap.map((item, index) => {
            return (
              <Fragment key={item.id}>
                <RoadmapWrapper
                  key={`roadmap-${item.title}`}
                  isRight={index % 2 === 1}
                >
                  <TextBlock>
                    <Logo $size={48}>
                      <img src={item.logo} alt={`roadmap-logo-${index}`} />
                    </Logo>
                    <H2>{item.title}</H2>
                    <H4>{item.subtitle}</H4>
                  </TextBlock>
                  <img src={item.image} alt={`roadmap-${index}`} />
                </RoadmapWrapper>
                {index !== 5 && (
                  <Connector
                    src={connectors[index]}
                    alt="connector dotted line"
                  />
                )}
              </Fragment>
            );
          })
        : null}
    </Wrapper>
  );
};

export default CombatsRoadmap;

CombatsRoadmap.propTypes = {
  goalUID: PropTypes.string.isRequired
};
